export default __webpack_public_path__ + "static/media/cardImg1.f296eeaa.png";